import styles from './index.scss';
import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames/bind';
import LoginBasicBox from '@/components/auth/login-basic-box/login-basic-box';
import LanguageSelect from '@/components/language-select/language-select';
import { Button } from 'react-bootstrap';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import i18n from 'i18next';
import { useLevvelTranslation } from '@/hooks/useLevvelTranslation';
import { DATE_SLASH_FORMAT_DAYJS } from '@/constants/system';

const cx = classnames.bind(styles);

dayjs.extend(utc);

// UI frozen from legacy. Batch 003 changes only the data source (props, not
// localStorage/jwt) and the button label (driven by `isLast`, not the doc type —
// so a single-doc gate's only step still reads "确认"). Visual/interaction
// (scroll-to-enable-checkbox, checkbox-to-enable-button, two-step titles, update
// banner, publish date, language) are unchanged.
const TosppBasicBox = (props: any) => {
  const { lt } = useLevvelTranslation();
  const { info, isLast, isLoading } = props;
  const [disableChecked, setDisableChecked] = useState(true);
  const [checked, setChecked] = useState(false);
  const contentRef = useRef<HTMLElement>(null);

  const handleChecked = (e: any) => {
    setChecked(e.target.checked);
  };

  useEffect(() => {
    if (info?.type === 2 && contentRef.current) {
      contentRef.current.scrollTop = 0;
      setDisableChecked(true);
      setChecked(false);
    }
  }, [info?.type]);

  const handleScroll = () => {
    const node = contentRef.current;
    if (
      node &&
      node.scrollHeight - node.scrollTop >= node.clientHeight - 5 &&
      info.content
    ) {
      setDisableChecked(false);
    }
  };

  const formatText = (text: string) =>
    i18n.language === 'en' ? text : text.toLocaleLowerCase();

  return (
    <LoginBasicBox innerBoxPadding={true}>
      <div className={styles.container}>
        <section className={cx([styles.header, 'd-flex align-items-center'])}>
          <div className={styles.language}>
            <LanguageSelect />
          </div>
          <h3 className={styles.title}>
            {info.type === 1
              ? lt('cdb_terms_of_service_text')
              : lt('cdb_privacy_policy_text')}
          </h3>
        </section>
        <section
          className={cx([styles.content])}
          ref={contentRef}
          onScroll={handleScroll}>
          {info?.hasUpdate && (
            <div className={styles.hasUpdate}>
              <b>
                {lt('cdb_terms_of_service_updated_text', {
                  type: formatText(
                    info?.type === 1
                      ? lt('cdb_terms_of_service_text')
                      : lt('cdb_privacy_policy_text')
                  ),
                })}
              </b>{' '}
              {lt('cdb_read_agree_terms_pp_text')}
            </div>
          )}
          {info?.publishedAt && (
            <div className={styles.updateTime}>
              {lt('cdb_updated_text')}{' '}
              {dayjs(info.publishedAt * 1000).format(DATE_SLASH_FORMAT_DAYJS)}
            </div>
          )}
          <div
            className={styles.innerContent}
            dangerouslySetInnerHTML={{ __html: info.content }}
          />
        </section>
        <section className={cx([styles.footer, 'd-flex align-items-center'])}>
          <div className={styles.operate}>
            <div className="d-flex align-items-center">
              <div>
                <input
                  type="checkbox"
                  id="service"
                  className="select-check form-check-input mb-1"
                  checked={checked}
                  disabled={disableChecked}
                  onChange={handleChecked}
                />
              </div>
              <label
                htmlFor="service"
                className={cx([
                  {
                    disableLabel: disableChecked,
                  },
                  'form-check-label select-option-color ml-2',
                ])}>
                {lt('cdb_agree_with_the_text')}{' '}
                {info.type === 1
                  ? lt('cdb_agree_terms_of_service_text')
                  : lt('cdb_agree_privacy_policy_text')}
              </label>
            </div>
            <div className={cx([styles.btn, 'mb-1'])}>
              <Button
                className={cx(['title-semiBold'])}
                disabled={!checked || isLoading}
                onClick={() => {
                  props.handleSubmit(info);
                }}
                type="button">
                {isLoading && (
                  <span>
                    <span
                      className="spinner-border spinner-border-md"
                      role="status"
                      aria-hidden="true"
                    />
                    &nbsp;&nbsp;
                  </span>
                )}
                {isLast ? lt('cdb_confirm_text') : lt('cdb_next_text')}
              </Button>
            </div>
          </div>
        </section>
      </div>
    </LoginBasicBox>
  );
};

export default TosppBasicBox;
